import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IUpdateSiteAvailabilityParams {
  ids: string[]; // row ids, not urlNames
  availability: string;
}

export interface IUpdateSiteAvailabilityResult extends IResult {
}

export class UpdateSiteAvailabilityRequest extends Request<IUpdateSiteAvailabilityParams, IUpdateSiteAvailabilityResult> {
  constructor(params: IUpdateSiteAvailabilityParams) {
    super('updateSiteAvailability', params);
  }
}
